export default () => ({
	loading: false,
	currentPage: 1,
	totalPages: 1,
	sectionId: '',

	init() {
		const el = this.$el as HTMLElement
		this.currentPage = parseInt(el.dataset.currentPage || '1', 10)
		this.totalPages = parseInt(el.dataset.totalPages || '1', 10)
		this.sectionId = el.dataset.sectionId || ''
	},

	get hasMore() {
		return this.currentPage < this.totalPages
	},

	async loadMore() {
		if (this.loading || !this.hasMore) return
		this.loading = true

		const nextPage = this.currentPage + 1

		try {
			const params = new URLSearchParams(window.location.search)
			params.set('page', String(nextPage))
			params.set('section_id', this.sectionId)
			const url = `${window.location.pathname}?${params.toString()}`

			const response = await fetch(url)
			const html = await response.text()
			const doc = new DOMParser().parseFromString(html, 'text/html')
			const newGrid = doc.querySelector('[data-product-grid]')

			if (newGrid) {
				const sentinel = this.$el.querySelector('[data-scroll-sentinel]')
				const newCards = newGrid.querySelectorAll('[data-product-card]')
				newCards.forEach((card) => {
					this.$el.insertBefore(card, sentinel)
				})
			}

			this.currentPage = nextPage
		} catch (e) {
			// Silently fail — user can still scroll/navigate
		} finally {
			this.loading = false
		}
	},
})
